<template>
<mdb-container fluid>
	<h2 class="h1-responsive font-weight-bold text-center my-4 ourProjects">Our Projects</h2>
	<mdb-row>
		<video playsinline autoplay loop controls>
			<source src="@/assets/projects-cropped.mp4" type="video/mp4"> 
			<!-- <source src="@/assets/drone-cropped.mp4" type="video/mp4">  -->
		</video>
	</mdb-row>

	<mdb-row class="mb-4 mt-5">
		<mdb-col md="1"></mdb-col>
		<mdb-col>
			<router-link :to="{name: 'Project', params: {projectName: folly_hill.URL, projectData: folly_hill} }">
				<mdb-view hover class="rounded z-dept-1-half mb-lg-0 mb-4">
					<img class="img-fluid projectImage" src="@/assets/Projects/Project/foley_hill.png" alt="Foley Hill" />
					<a>
						<mdb-mask overlay="white-slight" waves/>
					</a>
				</mdb-view>
				<mdb-card-title class="text-center projectsTitle">Folly Hill, Farnham</mdb-card-title>
				<mdb-card-title class="text-center projectsTitleCustomer mt-0">CALA Homes</mdb-card-title>
			</router-link>
		</mdb-col>

		<mdb-col>
			<router-link :to="{name: 'Project', params: {projectName: bury_farm.URL, projectData: bury_farm} }">
				<mdb-view hover class="rounded z-dept-1-half mb-lg-0 mb-4">
					<img class="img-fluid projectImage" src="@/assets/Projects/Project/bury_farm.png" alt="Bury Farm" />
					<a>
						<mdb-mask overlay="white-slight" waves/>
					</a>
				</mdb-view>
				<mdb-card-title class="text-center projectsTitle">Bury Farm, Whiteley</mdb-card-title>
				<mdb-card-title class="text-center projectsTitleCustomer mt-0">Crest Nicholson</mdb-card-title>
			</router-link>
		</mdb-col>

		<mdb-col>
			<router-link :to="{name: 'Project', params: {projectName: copthorne_road.URL, projectData: copthorne_road} }">
				<mdb-view hover class="rounded z-dept-1-half mb-lg-0 mb-4">
					<img class="img-fluid projectImage" src="@/assets/Projects/Project/copthorne_road.png" alt="Copthorne Road" />
					<a>
						<mdb-mask overlay="white-slight" waves/>
					</a>
				</mdb-view>
				<mdb-card-title class="text-center projectsTitle">Copthorne Road, Felbridge</mdb-card-title>
				<mdb-card-title class="text-center projectsTitleCustomer mt-0">Abbey Homes</mdb-card-title>
			</router-link>
		</mdb-col>

		<mdb-col>
			<router-link :to="{name: 'Project', params: {projectName: ham_lane.URL, projectData: ham_lane} }">
				<mdb-view hover class="rounded z-dept-1-half mb-lg-0 mb-4">
					<img class="img-fluid projectImage" src="@/assets/Projects/Project/ham_lane.png" alt="Ham Lane" />
					<a>
						<mdb-mask overlay="white-slight" waves/>
					</a>
				</mdb-view>
				<mdb-card-title class="text-center projectsTitle">Ham Lane, Lenham</mdb-card-title>
				<mdb-card-title class="text-center projectsTitleCustomer mt-0">Jones Homes</mdb-card-title>
			</router-link>
		</mdb-col>

		<mdb-col md="1"></mdb-col>
	</mdb-row>

	<mdb-row>
		<mdb-col md="1"></mdb-col>
		<mdb-col>
			<router-link :to="{name: 'Project', params: {projectName: jackdaw.URL, projectData: jackdaw} }">
				<mdb-view hover class="rounded z-dept-1-half mb-lg-0 mb-4">
					<img class="img-fluid projectImage" src="@/assets/Projects/Project/jackdaw.png" alt="Jackdaw Lane" />
					<a>
						<mdb-mask overlay="white-slight" waves/>
					</a>
				</mdb-view>
				<mdb-card-title class="text-center projectsTitle">Jackdaw Lane, Horsham</mdb-card-title>
				<mdb-card-title class="text-center projectsTitleCustomer mt-0">CALA Homes</mdb-card-title>
			</router-link>
		</mdb-col>

		<mdb-col>
			<!-- <router-link :to="{name: 'Project', params: {projectName: jackdaw.URL, projectData: jackdaw} }"> -->
				<mdb-view hover class="rounded z-dept-1-half mb-lg-0 mb-4">
					<img class="img-fluid projectImage" src="@/assets/Projects/Project/alford.png" alt="Alford" />
					<a>
						<mdb-mask overlay="white-slight" waves/>
					</a>
				</mdb-view>
				<mdb-card-title class="text-center projectsTitle">Alford</mdb-card-title>
				<mdb-card-title class="text-center projectsTitleCustomer mt-0">CALA Homes</mdb-card-title>
			<!-- </router-link> -->
		</mdb-col>

		<mdb-col>
			<router-link :to="{name: 'Project', params: {projectName: fiveoaks.URL, projectData: fiveoaks} }">
				<mdb-view hover class="rounded z-dept-1-half mb-lg-0 mb-4">
					<img class="img-fluid projectImage" src="@/assets/Projects/Project/fiveoaks.png" alt="Fiveoaks Road" />
					<a>
						<mdb-mask overlay="white-slight" waves/>
					</a>
				</mdb-view>
				<mdb-card-title class="text-center projectsTitle">Fiveoaks Road, Broadbridge Heath</mdb-card-title>
				<mdb-card-title class="text-center projectsTitleCustomer mt-0">Abbey Homes</mdb-card-title>
			</router-link>
		</mdb-col>

		<mdb-col>
			<router-link :to="{name: 'Project', params: {projectName: hailwood.URL, projectData: hailwood} }">
				<mdb-view hover class="rounded z-dept-1-half mb-lg-0 mb-4">
					<img class="img-fluid projectImage" src="@/assets/Projects/Project/haliwood_place.png" alt="Ham Lane" />
					<a>
						<mdb-mask overlay="white-slight" waves/>
					</a>
				</mdb-view>
				<mdb-card-title class="text-center projectsTitle">Hailwood Place, West Kingsdown</mdb-card-title>
				<mdb-card-title class="text-center projectsTitleCustomer mt-0">Brookworth Homes</mdb-card-title>
			</router-link>
		</mdb-col>

		<mdb-col md="1"></mdb-col>
	</mdb-row>
</mdb-container>  
</template>

<script>

import { mdbContainer, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbMask, mdbIcon, mdbView, mdbBtn, mdbCardTitle } from 'mdbvue';
import VueAxios from 'vue-axios'
import Project from '@/components/Project';

export default {
    name: 'Projects',
    components: {
      mdbContainer,
      mdbRow,
      mdbCol,
      mdbCard,
      mdbCardBody,
      mdbMask,
      mdbIcon,
      mdbView,
      mdbBtn,
			mdbCardTitle,
	  Project
    },
	data() {
		return {
			allProjects : null,
			otherUrl: "http://localhost:8080/",
			baseUrl : "http://akingscote.co.uk/",

			folly_hill : {
				  URL: "folly_hill",
					Title : "Folly Hill, Farnham",
					Details : "Working on behalf of ‘CALA Homes,’ our site in Farnham launched in November 2019. The development offers a tricky terrain with 96 new homes being built. The site offers plenty of retaining wall structures, a large basin at the bottom end of the site and a foul pumping station. As part of the package that was offered, the section 278 was to construct a roundabout to allow access into the development. Along with existing services, existing sewers and a constant flow of busy traffic, the results were fantastic. With a dedicated site team, Folly Heights is a stunning development which offers some spectacular views!",
					ProjectLatitude : 51.2287378,
					ProjectLongitude : -0.8077469,
					CustomerLogo : {
						url:	"cala.png",
						alt: "cala"
					},
					Images: [
						{ url: "folly_hill_farnham/shopped/1.png", alt: "Folly Hill Image 1" },
						{ url: "folly_hill_farnham/shopped/2.png", alt: "Folly Hill Image 2" },
						{ url: "folly_hill_farnham/shopped/3.png", alt: "Folly Hill Image 3" },
						{ url: "folly_hill_farnham/shopped/4.png", alt: "Folly Hill Image 4" }
					]
			},

			bury_farm : {
					URL: "bury_farm",
					Title : "Bury Farm, Whiteley",
					Details : "Located in the Hampshire village of Curbridge, ‘Curbridge Meadows’ is part of the wider ‘Whiteley Meadows’ development which will include two new primary schools, a secondary school, two neighbourhood centres and plenty more. Working on behalf of ‘Crest Nicholson,’ our part of ‘Curbridge Meadows’ site will offer 69 new homes and some stunning retaining wall structures.",
					ProjectLatitude : 50.897521,
					ProjectLongitude : -1.259195,
					CustomerLogo : {
						url:	"crest.png",
						alt: "crest"
					},
					Images: [
						{ url: "bury_farm_whiteley/shopped/1.png", alt: "Bury Farm Image 1" },
						{ url: "bury_farm_whiteley/shopped/2.png", alt: "Bury Farm Image 2" },
						{ url: "bury_farm_whiteley/shopped/3.png", alt: "Bury Farm Image 3" }
					]
			},

			copthorne_road : {
					URL: "copthorne",
					Title : "Copthorne Road, Felbridge",
					Details : "Situated on the busy A264, our site on Copthorne Road will offer 26 new homes. We have worked with ‘Abbey Homes’ in the past at our recently completed project in Broadbridge Heath. The beginning of this project saw us become principal contractors for approximately 12 weeks. During this period, all sewers, access roads and show homes were all complete and handed over. Along with excavating foundations, installing sewer connections and a large retaining wall structure to keep the ‘Felbridge water’ stream on course, some S278 works was included in the package and can be seen when passing on the A264.",
					ProjectLatitude : 51.138676,
					ProjectLongitude : -0.041393,
					CustomerLogo : {
						url:	"abbey.png",
						alt: "abbey"
					},
					Images: [
						{ url: "copthorne_road_felbridge/shopped/1.png", alt: "Copthorne Image 1" },
						{ url: "copthorne_road_felbridge/shopped/2.png", alt: "Copthorne Image 2" },
						{ url: "copthorne_road_felbridge/shopped/3.png", alt: "Copthorne Image 3" },
						{ url: "copthorne_road_felbridge/shopped/4.png", alt: "Copthorne Image 4" }
					]
			},

			ham_lane : {
					URL: "ham_lane",
					Title : "Ham Lane, Lenham",
					Details : "'Westwood Park', which started Summer 2019 is located in Lenham, Kent. This site consists of 2 surface water basins, a pump station, S278 works & 70 new homes. Working alongside ‘Jones Homes,’ our dedicated site team have been great in meeting CML dates and keeping ahead of build schedules setting a great example to other trades involved.",
					ProjectLatitude : 51.238129,
					ProjectLongitude : 0.7101813,
					CustomerLogo : {
						url:	"jones.png",
						alt: "jones"
					},
					Images: [
						{ url: "ham_lane_lenham/shopped/1.png", alt: "Ham Lane Image 1" },
						{ url: "ham_lane_lenham/shopped/2.png", alt: "Ham Lane Image 2" },
						{ url: "ham_lane_lenham/shopped/3.png", alt: "Ham Lane Image 3" }
					]
			},

			fiveoaks : {
					URL: "fiveoaks",
					Title : "Fiveoaks Road, Broadbridge Heath",
					Details : "Broadbridge Heath, our first development working for Abbey Homes. The local area has had a lot of development in recent years, and we were fortunate enough to have played a part in this. From day one, this site was a success. Some exquisite finishing, great organization, and a stunning product handed over to our equally happy client. This site can be found along the newly constructed ‘Broadbridge Way’ just off the A281.",
					ProjectLatitude : 51.067233,
					ProjectLongitude : -0.3691132,
					CustomerLogo : {
						url:	"abbey.png",
						alt: "abbey"
					},
					Images: [
						{ url: "fiveoaks_road_broadbridge_heath/shopped/1.png", alt: "Fiveoaks Image 1" },
						{ url: "fiveoaks_road_broadbridge_heath/shopped/2.png", alt: "Fiveoaks Image 2" },
						{ url: "fiveoaks_road_broadbridge_heath/shopped/3.png", alt: "Fiveoaks Image 3" },
						{ url: "fiveoaks_road_broadbridge_heath/shopped/4.png", alt: "Fiveoaks Image 4" }	
					]
			},

			jackdaw : {
					URL: "jackdaw",
					Title : "Jackdaw Lane, Horsham",
					Details : "Jackdaw Lane, Horsham working on behalf of ‘CALA Homes.’ With some S278 works, attenuation tanks, piled foundations along with the installation of permeable paving roads and sleeper retaining walls, this project was another successful product handed over to 'CALA Homes.'",
					ProjectLatitude : 51.0798627,
					ProjectLongitude : -0.3127129,
					CustomerLogo : {
						url:	"cala.png",
						alt: "cala"
					},
					Images: [
						{ url: "jackdaw_lane_horsham/shopped/1.png", alt: "Jackdaw Image 1" },
						{ url: "jackdaw_lane_horsham/shopped/2.png", alt: "Jackdaw Image 2" },
						{ url: "jackdaw_lane_horsham/shopped/3.png", alt: "Jackdaw Image 3" },
						{ url: "jackdaw_lane_horsham/shopped/4.png", alt: "Jackdaw Image 4" }
					]
			},

			hailwood : {
					URL: "hailwood",
					Title : "Hailwood Place, West Kingsdown",
					Details : "‘Hailwood Place’ was our first time working alongside ‘Brookworth Homes.’ The site team were apart of this development from day one. With the project consisting of 6 stunning new homes with their own private road leading into a circular site with a large landscaped area in the middle. Indian sandstone paving and block paved driveways were just the final touches to make this site very appealing to the eye.",
					ProjectLatitude : 51.3330542,
					ProjectLongitude : 0.2682446,
					CustomerLogo : {
						url:	"brookworth.png",
						alt: "brookworth"
					},
					Images: [
						{ url: "haliwood_place_west_kingsdown/shopped/1.png", alt: "Haliwood Image 1" },
						{ url: "haliwood_place_west_kingsdown/shopped/2.png", alt: "Haliwood Image 2" },
						{ url: "haliwood_place_west_kingsdown/shopped/3.png", alt: "Haliwood Image 3" },
						{ url: "haliwood_place_west_kingsdown/shopped/4.png", alt: "Haliwood Image 4" }
					]
			}

		}		
	},
}
</script>
<style>
</style>
